import { createFetchMaintenanceMessagePath } from '@routing/apiUrls';
import { executeGetRequest, FetchConfig } from '@api/client';
import { FetchMaintenanceMessageResponse } from '@models/maintenanceMessage/FetchMaintenanceMessage';

export const fetchMaintenanceMessage = async (config?: FetchConfig) => {
    const result = await executeGetRequest<FetchMaintenanceMessageResponse>(createFetchMaintenanceMessagePath(), config);
    return result.data;
};
